import {Component, inject, OnInit, signal, WritableSignal} from '@angular/core';
import {Router} from '@angular/router';
import {UserDetailsResponse, Role, User} from '@models/user.interface';
import {MobileNavService} from '@services/frontend/mobile-nav.service';
import {UserStateService} from '@services/frontend/user-state.service';
import {HeaderUser} from './header-user/header-user';

@Component({
  selector: 'app-header',
  imports: [HeaderUser],
  templateUrl: './header.html',
  standalone: true,
})
export class Header implements OnInit {
  private readonly userStateService = inject(UserStateService);
  private readonly router = inject(Router);
  protected readonly mobileNav = inject(MobileNavService);

  isInitialized: WritableSignal<boolean> = signal(false);
  user$: WritableSignal<User> = signal<User>({} as UserDetailsResponse);
  settingsUrl: WritableSignal<string> = signal('');

  ngOnInit() {
    const user = this.userStateService.getUser()()!;
    this.user$.set(user);
    this.settingsUrl.set(this.computeSettingsUrl(user));
    this.isInitialized.set(true);
  }

  private computeSettingsUrl(user: User): string {
    if (user.role === Role.ACCOUNTANT || user.role === Role.ADMIN) {
      return '/dashboard/expert/parametres';
    }
    const match = this.router.url.match(/\/dashboard\/company\/([^/]+)/);
    if (match) {
      return `/dashboard/company/${match[1]}/parametres`;
    }
    return '';
  }

  protected readonly Role = Role;
}
